<template>
    <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3 template-wrapper">

        <!-- alpha fix- added this  -->
        <p class="mt-3" style="font-size: 15px; padding-bottom: 10px;">Create, review and manage all your automated email notifications.</p>
        <div v-for="category in categories" :key="category.value">
            <template v-if="category.value == 1 || category.value == 2">
                <!-- alpha fix-removed  border-bottom  -->
                <div class="mb-4 pb-4">
                      <!-- alpha fix-removed  border-bottom  -->
                    <div class="clearfix row py-2 mb-2">
                        <div class="col-sm-3 px-3 company-form-box-title">{{ category.text }} </div>
                    </div>
                    <template v-if="category.value == 1 || category.value == 2">
                        <div class="col-sm-12  px-0">
                            <b-overlay :show="showoverlay_list" rounded="sm">
                                <table class="table list-tables" :id="category.value" :per-page="perPage"
                                    :current-page="currentPage">
                                    <thead>
                                        <tr class="table-head">
                                            <!-- alpha fix- removed pl-5  -->
                                            <td class="">#</td>
                                            <td>Template Title</td>
                                            <td v-if="ce" class="">Action</td>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr class="hover-bg table-row border-bottom mx-2"
                                            v-for="(template, n) in templates[category.value]" :key="template.id">
                                            <!-- alpha fix- removed pl-5 and added text-center  -->
                                            <td class="col-md-1 align-middle list-columns text-center">{{ n + 1 }}---{{
                                                category.value }}</td>
                                            <td class="col-md-5 align-middle list-columns">
                                                <div class="">{{ template.title }}
                                                    <span class="badge-pill m-3 green-bg"
                                                        v-if="template.company_id == 0">Default</span>
                                                    <b-icon icon="check-circle-fill" variant="success"
                                                        aria-hidden="true"
                                                        v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)"></b-icon>

                                                </div>
                                            </td>
                                            <td class="clearfix col-md-4 align-middle" v-if="ce">
                                                <div class="float-right mr-2 position-relative">
                                                    <b-button-toolbar>
                                                        <!-- Abdullah26 added px-1 and text-left  -->
                                                        <a id="actionDropdown"
                                                            class="dropdown-toggle clearfix action-dropdown-toggle"
                                                            style="font-size: 16px;" href="#" role="button"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false"><b-icon
                                                                icon="three-dots-vertical"></b-icon></a>
                                                        <div class="dropdown-menu action-dropdown-menu px-1"
                                                            aria-labelledby="actionDropdown" style="width:230px">
                                                            <b-button-group class="mr-1">
                                                                <b-button class="rounded delete-btn text-left"
                                                                    title="Send Sample Email"
                                                                    @click="send_sample(template.id)">
                                                                    <b-icon icon="envelope" class="mr-2"
                                                                        aria-hidden="true"></b-icon>Send Sample Mail
                                                                </b-button>

                                                                <template v-if="$acl['templates/list'] > 1">
                                                                    <b-button class="rounded delete-btn text-left"
                                                                        title="Preview Details"
                                                                        @click="previewTemplate(template.id)">
                                                                        <i class="fas fa-list"> </i>Preview
                                                                    </b-button>
                                                                </template>


                                                                <template v-if="$acl['templates/list'] > 1">

                                                                    <template v-if="template.company_id == 0">
                                                                        <b-button class="rounded delete-btn text-left"
                                                                            title="Duplicate Template Details"
                                                                            @click="duplicate_template(template.id)">
                                                                            <b-icon icon="clipboard-plus" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Duplicate
                                                                        </b-button>

                                                                        <template
                                                                            v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="This Template is Active">
                                                                                <b-icon icon="check-circle-fill"
                                                                                    variant="success"
                                                                                    aria-hidden="true"></b-icon>Active
                                                                                Template
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-else>
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Make This Template Active"
                                                                                @click="make_default(template.id)">
                                                                                <b-icon icon="arrow-right-circle"
                                                                                    class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Make
                                                                                Active
                                                                            </b-button>
                                                                        </template>
                                                                    </template>


                                                                    <template v-else>

                                                                        <b-button class="mr-3 rounded edit-btn text-left"
                                                                            title="Edit Template Details"
                                                                            @click="editTemplate(template.id, 1)">
                                                                            <b-icon icon="pencil" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Edit
                                                                        </b-button>
                                                                        <b-button class="rounded delete-btn text-left"
                                                                            title="Delete Template Details"
                                                                            @click="deleteTemplate(template.id)">
                                                                            <b-icon icon="trash" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Delete
                                                                        </b-button>
                                                                        <template
                                                                            v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="This Template is Active">
                                                                                <b-icon icon="check-circle-fill"
                                                                                    variant="success"
                                                                                    aria-hidden="true"></b-icon>Active
                                                                                Template
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-else>
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Make This Template Active"
                                                                                @click="make_default(template.id)">
                                                                                <b-icon icon="arrow-right-circle"
                                                                                    class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Make
                                                                                Active
                                                                            </b-button>
                                                                        </template>

                                                                    </template>
                                                                </template>
                                                            </b-button-group>
                                                        </div>
                                                    </b-button-toolbar>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                                    <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->

                            </b-overlay>
                        </div>
                    </template>

                </div>

            </template>
            <template v-if="category.value == 3 || category.value == 4 || category.value == 9">
                <!-- alpha fix- removed border-bottom added company-form-container and px-3 -->
                <div class="mb-4 pb-4 company-form-container px-3">

                     <!-- alpha fix- removed border-bottom  -->
                    <div class="clearfix row py-2 mb-2 ">
                        <div class="col-sm-12 px-3 company-form-box-title">{{ category.text }} </div>
                        <!-- <div class="col-sm-9 float-right text-right pr-0">

                            <b-button id="show-btn" class="mr-3" v-if="ce" @click="addNew(category.value)"><b-icon icon="plus" ></b-icon>Add New {{category.text}}</b-button>
                        </div> -->
                    </div>

                    <template v-if="category.value == 3 || category.value == 4 || category.value == 9">


                        <template v-for="sub_cat in category.sub_category">

                             <!-- alpha fix- removed border-bottom  -->
                            <div class="clearfix row py-2 mb-2 ">
                                <div class="col-sm-12 px-12 company-form-box-title">{{ sub_cat.text }} </div>

                            </div>

                            <div class="col-sm-12  px-0">
                                <b-overlay :show="showoverlay_list" rounded="sm">
                                    <table class="table list-tables" :id="category.value" :per-page="perPage"
                                        :current-page="currentPage">
                                        <thead>
                                            <tr class="table-head">
                                                 <!-- alpha fix- removed pl-5  -->
                                                <td class="">#</td>
                                                <td>Template Title</td>


                                                <td v-if="ce" class="">Action</td>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="hover-bg table-row border-bottom mx-2"
                                                v-for="(template, n) in (templates[category.value] || []).filter(t => t.module_type == sub_cat.value)"
                                                :key="template.id">
                                                <!-- alpha fix- removed pl-5 and added text-center  -->
                                                <td class="col-md-1 align-middle list-columns text-center">{{ n + 1 }}</td>
                                                <td class="col-md-5 align-middle list-columns">
                                                    <div class="">{{ template.title }}
                                                        <span class="badge-pill m-3 green-bg"
                                                            v-if="template.company_id == 0">Default</span>
                                                        <b-icon icon="check-circle-fill" variant="success"
                                                            aria-hidden="true"
                                                            v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)"></b-icon>
                                                    </div>
                                                </td>
                                                <td class="clearfix col-md-4 align-middle" v-if="ce">
                                                    <div class="float-right mr-2 position-relative">
                                                        <b-button-toolbar>
                                                            <a id="actionDropdown"
                                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                                style="font-size: 16px;" href="#" role="button"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"><b-icon
                                                                    icon="three-dots-vertical"></b-icon></a>
                                                                      <!-- alpha fix- aaded class px-1  -->
                                                            <div class="dropdown-menu action-dropdown-menu px-1"
                                                                aria-labelledby="actionDropdown" style="width:230px">
                                                                <b-button-group class="mr-1">
                                                                      <!-- alpha fix- aaded class text-left  -->
                                                                    <b-button class="rounded delete-btn text-left"
                                                                        title="Send Sample Email"
                                                                        @click="send_sample(template.id)">
                                                                        <b-icon icon="envelope" class="mr-2"
                                                                            aria-hidden="true"></b-icon>Send Sample Mail
                                                                    </b-button>
                                                                    <template v-if="$acl['templates/list'] > 1">
                                                                          <!-- alpha fix- aaded class text-left  -->
                                                                        <b-button class="rounded delete-btn text-left"
                                                                            title="Preview Details"
                                                                            @click="previewTemplate(template.id)">
                                                                            <i class="fas fa-list"> </i>Preview
                                                                        </b-button>
                                                                    </template>
                                                                    <template v-if="$acl['templates/list'] > 1">
                                                                        <template v-if="template.company_id == 0">
                                                                              <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Duplicate Template Details"
                                                                                @click="duplicate_template(template.id)">
                                                                                <b-icon icon="clipboard-plus"
                                                                                    class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Duplicate
                                                                            </b-button>

                                                                            <template
                                                                                v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                                  <!-- alpha fix- aaded class text-left  -->
                                                                                <b-button class="rounded delete-btn text-left"
                                                                                    title="This Template is Active">
                                                                                    <b-icon icon="check-circle-fill"
                                                                                        variant="success"
                                                                                        aria-hidden="true"></b-icon>Active
                                                                                    Template
                                                                                </b-button>
                                                                            </template>
                                                                            <template v-else>
                                                                                  <!-- alpha fix- aaded class text-left  -->
                                                                                <b-button class="rounded delete-btn text-left"
                                                                                    title="Make This Template Active"
                                                                                    @click="make_default(template.id)">
                                                                                    <b-icon icon="arrow-right-circle"
                                                                                        class="mr-2"
                                                                                        aria-hidden="true"></b-icon>Make
                                                                                    Active
                                                                                </b-button>
                                                                            </template>

                                                                        </template>
                                                                        <template v-else>
                                                                              <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="mr-3 rounded edit-btn text-left"
                                                                                title="Edit Template Details"
                                                                                @click="editTemplate(template.id, 1)">
                                                                                <b-icon icon="pencil" class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Edit
                                                                            </b-button>
                                                                              <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Delete Template Details"
                                                                                @click="deleteTemplate(template.id)">
                                                                                <b-icon icon="trash" class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Delete
                                                                            </b-button>

                                                                            <template
                                                                                v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                                  <!-- alpha fix- aaded class text-left  -->
                                                                                <b-button class="rounded delete-btn text-left"
                                                                                    title="This Template is Active">
                                                                                    <b-icon icon="check-circle-fill"
                                                                                        variant="success"
                                                                                        aria-hidden="true"></b-icon>Active
                                                                                    Template
                                                                                </b-button>
                                                                            </template>
                                                                            <template v-else>
                                                                                  <!-- alpha fix- aaded class text-left  -->
                                                                                <b-button class="rounded delete-btn text-left"
                                                                                    title="Make This Template Active"
                                                                                    @click="make_default(template.id)">
                                                                                    <b-icon icon="arrow-right-circle"
                                                                                        class="mr-2"
                                                                                        aria-hidden="true"></b-icon>Make
                                                                                    Active
                                                                                </b-button>
                                                                            </template>

                                                                        </template>
                                                                    </template>
                                                                </b-button-group>
                                                            </div>
                                                        </b-button-toolbar>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                                    <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->

                                </b-overlay>
                            </div>

                        </template>


                    </template>

                    <template v-else>
                        <div class="col-sm-12  px-0">
                            <b-overlay :show="showoverlay_list" rounded="sm">
                                <table class="table list-tables" :id="category.value" :per-page="perPage"
                                    :current-page="currentPage">
                                    <thead>
                                        <tr class="table-head">
                                             <!-- alpha fix- removed pl-5  -->
                                            <td class="col-md-1">#</td>
                                            <td lass=" col-md-5">Template Title</td>

                                            <td lass=" col-md-4" v-if="ce">Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="hover-bg table-row border-bottom mx-2"
                                            v-for="(template, n) in templates[category.value]" :key="template.id">
                                            <!-- alpha fix- removed pl-5 and added text-center  -->
                                            <td class="col-md-1 align-middle list-columns text-center">{{ n + 1 }}</td>
                                            <td class="col-md-5 align-middle list-columns">
                                                <div class="">{{ template.title }}
                                                    <span class="badge-pill m-3 green-bg"
                                                        v-if="template.company_id == 0">Default</span>
                                                    <b-icon icon="check-circle-fill" variant="success"
                                                        aria-hidden="true"
                                                        v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)"></b-icon>

                                                </div>

                                            </td>
                                            <td class="col-md-2 align-middle list-columns">
                                                <div v-if="template.company_id == 0" style="font-size:14px;">

                                                    <template v-if="default_templates[template.id]">
                                                        {{
                                                            default_signatories[default_templates[template.id].signature_id]
                                                        }}
                                                    </template>
                                                    <template v-else>

                                                    </template>
                                                </div>
                                                <div v-if="template.company_id != 0" style="font-size:14px;">
                                                    {{ default_signatories[template.signature_id] }}</div>
                                            </td>


                                            <td class="clearfix col-md-6 align-middle" v-if="ce">
                                                <div class="float-right mr-2 position-relative">
                                                    <b-button-toolbar>
                                                        <a id="actionDropdown"
                                                            class="dropdown-toggle clearfix action-dropdown-toggle"
                                                            style="font-size: 16px;" href="#" role="button"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false"><b-icon
                                                                icon="three-dots-vertical"></b-icon></a>
                                                                <!-- alpha fix added px-1  -->
                                                        <div class="dropdown-menu action-dropdown-menu px-1"
                                                            aria-labelledby="actionDropdown" style="width:230px">
                                                            <b-button-group class="mr-1">
                                                                <!-- alpha fix- aaded class text-left  -->
                                                                <b-button class="rounded delete-btn text-left"
                                                                    title="Send Sample Email"
                                                                    @click="send_sample(template.id)">
                                                                    <b-icon icon="envelope" class="mr-2"
                                                                        aria-hidden="true"></b-icon>Send Sample Mail
                                                                </b-button>
                                                                <template v-if="$acl['templates/list'] > 1">
                                                                     <!-- alpha fix- aaded class text-left  -->
                                                                    <b-button class="rounded delete-btn text-left"
                                                                        title="Preview Details"
                                                                        @click="previewTemplate(template.id)">
                                                                        <i class="fas fa-list"> </i>Preview
                                                                    </b-button>
                                                                </template>
                                                                <template v-if="$acl['templates/list'] > 1">
                                                                    <template v-if="template.company_id == 0">
                                                                         <!-- alpha fix- aaded class text-left  -->
                                                                        <b-button class="rounded delete-btn text-left"
                                                                            title="Duplicate Template Details"
                                                                            @click="duplicate_template(template.id)">
                                                                            <b-icon icon="clipboard-plus" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Duplicate
                                                                        </b-button>



                                                                        <template
                                                                            v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                             <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="This Template is Active">
                                                                                <b-icon icon="check-circle-fill"
                                                                                    variant="success"
                                                                                    aria-hidden="true"></b-icon>Active
                                                                                Template
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-else>
                                                                             <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Make This Template Active"
                                                                                @click="make_default(template.id)">
                                                                                <b-icon icon="arrow-right-circle"
                                                                                    class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Make
                                                                                Active
                                                                            </b-button>
                                                                        </template>

                                                                    </template>
                                                                    <template v-else>
                                                                         <!-- alpha fix- aaded class text-left  -->
                                                                        <b-button class="mr-3 rounded edit-btn text-left"
                                                                            title="Edit Template Details"
                                                                            @click="editTemplate(template.id, 1)">
                                                                            <b-icon icon="pencil" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Edit
                                                                        </b-button>
                                                                         <!-- alpha fix- aaded class text-left  -->
                                                                        <b-button class="rounded delete-btn text-left"
                                                                            title="Delete Template Details"
                                                                            @click="deleteTemplate(template.id)">
                                                                            <b-icon icon="trash" class="mr-2"
                                                                                aria-hidden="true"></b-icon>Delete
                                                                        </b-button>

                                                                        <template
                                                                            v-if="(defaults[template.category] && defaults[template.category][template.module_type] == template.id)">
                                                                             <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="This Template is Active">
                                                                                <b-icon icon="check-circle-fill"
                                                                                    variant="success"
                                                                                    aria-hidden="true"></b-icon>Active
                                                                                Template
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-else>
                                                                             <!-- alpha fix- aaded class text-left  -->
                                                                            <b-button class="rounded delete-btn text-left"
                                                                                title="Make This Template Active"
                                                                                @click="make_default(template.id)">
                                                                                <b-icon icon="arrow-right-circle"
                                                                                    class="mr-2"
                                                                                    aria-hidden="true"></b-icon>Make
                                                                                Active
                                                                            </b-button>
                                                                        </template>

                                                                    </template>

                                                                </template>

                                                            </b-button-group>
                                                        </div>
                                                    </b-button-toolbar>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--<div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                            <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div>-->
                            </b-overlay>
                        </div>
                    </template>
                </div>
            </template>
        </div>


        <div class="row justify-content-center">

            <!-- template add/edit form -->
            <div class="col-sm-12  px-0" v-if="this.ce">
                <b-modal id="bv-modal-email-template" dialog-class="modal-xml" size="lg" hide-footer>
                    <template #modal-title> Edit Email Templates | {{ moduleTypeName }} </template>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="clearfix">

                                <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                                    <b-form-input id="name" name="name" v-model="fdata.title"
                                        v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                        aria-describedby="name-feedback" data-vv-as="Name"
                                        :readonly="default_edit == 0"></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="subject-group" label="Subject" class="required-field"
                                    label-for="subject">
                                    <b-form-input id="subject" name="subject" v-model="fdata.subject"
                                        v-validate="{ required: true, min: 3 }" :state="validateState('subject')"
                                        aria-describedby="subject-feedback" data-vv-as="Subject"
                                        :readonly="default_edit == 0"></b-form-input>
                                    <b-form-invalid-feedback id="subject-feedback">{{ veeErrors.first('subject')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>

                                <!-- <b-form-group id="type-group" label="Type" label-for="type">
                                    <b-form-select id="type" name="type" :disabled="fdata.id != null"
                                        v-model="fdata.module_type" @change="updatePlaceholders"
                                        v-validate="{ required: false }" :options="hr_cirtificate"
                                        :state="validateState('type')" aria-describedby="type-feedback"
                                        data-vv-as="Type"></b-form-select>

                                    <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('sub_category_id')
                                        }}</b-form-invalid-feedback>
                                </b-form-group> -->

                                <b-form-group id="attachment-group" :label="attachmentLabel" label-for="has_attachment">
                                    <b-form-checkbox id="has_attachment" v-model="fdata.has_attachment"
                                        name="has_attachment" value="1" unchecked-value="0" switch>
                                        {{ fdata.has_attachment == 1 ? 'Yes' : 'No' }}
                                    </b-form-checkbox>
                                </b-form-group>

                                <template v-if="default_edit == 0">
                                    <ckeditor :key="componentKey" @namespaceloaded="onNamespaceLoaded"
                                        :config="editorConfig_default" v-model="fdata.content"></ckeditor>
                                </template>
                                <template v-else>
                                    <ckeditor :key="componentKey" @namespaceloaded="onNamespaceLoaded"
                                        :config="editorConfig" v-model="fdata.content"></ckeditor>
                                </template>

                                <div class="mt-3">

                                    <template v-if="fdata.id > 0">
                                        <b-button type="submit" @click="duplicate(0)" variant="primary" style=""><b-icon
                                                variant="light" icon="pencil" scale="1" width="20px" height="20px"
                                                class="align-left mr-2"></b-icon>Save Template</b-button>
                                        <b-button type="submit" @click="duplicate(1)" variant="primary" style=""><b-icon
                                                variant="light" icon="clipboard-plus" scale="1" width="20px"
                                                height="20px" class="align-left mr-2"></b-icon>Duplicate
                                            Template</b-button>
                                    </template>
                                    <template v-else>
                                        <b-button type="submit" variant="primary" style=""><b-icon variant="light"
                                                icon="plus-circle" scale="1" width="20px" height="20px"
                                                class="align-left mr-2"></b-icon>Add Template</b-button>
                                    </template>

                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>


                <!-- add signatory to default template form -->



                <!-- add signatory to default template form end -->

                <!-- template preview form -->


                <b-modal id="bv-modal-email-template-preview" dialog-class="modal-xml" size="lg" hide-footer>
                    <template #modal-title> Preview of Email Templates | {{ moduleTypeName }} </template>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="fdata.id" name="id">


                            <div class="clearfix">

                                <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                                    <b-form-input id="name" name="name" v-model="fdata.title"
                                        v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                        aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="subject-group" label="Subject" class="required-field"
                                    label-for="subject">
                                    <b-form-input id="subject" name="subject" v-model="fdata.subject"
                                        v-validate="{ required: true, min: 3 }" :state="validateState('subject')"
                                        aria-describedby="subject-feedback" data-vv-as="Subject"></b-form-input>
                                    <b-form-invalid-feedback id="subject-feedback">{{ veeErrors.first('subject')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>

                                <input type="hidden" id="type" name="type" v-model="fdata.module_type">



                                <ckeditor :key="componentKey" @namespaceloaded="onNamespaceLoaded"
                                    :config="editorConfig_default" v-model="fdata.content"></ckeditor>
                                <div class="mt-3">
                                    <b-button type="submit" @click="duplicate(1)" variant="primary" style=""><b-icon
                                            variant="light" icon="clipboard-plus" scale="1" width="20px" height="20px"
                                            class="align-left mr-2"></b-icon>Duplicate Template</b-button>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
                <!--Afrin: Added for send sample email modal start-->
                <b-modal id="bv-modal-send-sample-email" dialog-class="modal-xml" size="md" hide-footer>
                    <template #modal-title> Send Sample Email </template>
                    <b-overlay :show="sample_email_overlay" rounded="sm">
                        <b-form @submit.stop.prevent="submitSendSample" class="">
                            <div class="clearfix">
                                <b-form-group id="sample-email-group" label="Enter the recipient email address:" class="required-field" label-for="sample_email">
                                    <b-form-input id="sample_email" name="sample_email" v-model="sample_email" v-validate="{ required: true, email: true }" :state="validateState('sample_email')" aria-describedby="sample-email-feedback" data-vv-as="Recipient Email" placeholder="Enter recipient email address"></b-form-input>
                                    <b-form-invalid-feedback id="sample-email-feedback">{{ veeErrors.first('sample_email') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <div class="mt-3">
                                    <b-button type="submit" variant="primary">
                                        <b-icon variant="light" icon="envelope" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Send Sample Mail
                                    </b-button>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
                <!--Afrin: Added for send sample email modal end-->
            </div>
        </div>
    </div>
</template>
<script>

export default {

    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;
        }
    },
    props: ['ce_flg', 'check_ce'],
    data() {

        return {

            componentKey: 1,

            editorConfig: {
                extraPlugins: ['placeholder_select', 'justify'],
                //extraPlugins: 'strinsert',
                placeholder_select: {
                    placeholders: [],
                    format: ' [[%placeholder%]] ',
                },
                allowedContent: true,
                /*stylesSet: 'my_styles',*/

            },

            editorConfig_default: {
                extraPlugins: ['placeholder_select', 'justify'],
                //extraPlugins: 'strinsert',
                placeholder_select: {
                    placeholders: [],
                    format: ' [[%placeholder%]] ',
                },
                readOnly: true, //aboni

            },


            default_templates: [],
            templates: [],
            placeholder: [],

            successmsg: false,
            warningmsg: false,
            dangermsg: false,

            showoverlay: false,
            showoverlay_list: false,
            movenext: false,

            errormsg: [],
            fdata: { id: null, title: '', subject: '', category: 3, module_type: 1, content: '', duplicate: 0, signature: 0, has_attachment: 1 },
            signature_fdata: {},
            // Afrin: Added for send sample email modal start
            sample_email_modal_template_id: null,
            sample_email: '',
            sample_email_overlay: false,
            // Afrin: Added for send sample email modal end

            search: '',
            length: 3,

            ce: true,

            content: '',

            pagination: { currentPage: 1, pages: 1 },
            perPage: 3,
            currentPage: 1,
            defaults: [],

            download_loader: '',
            download_text: '',
            signatories: [],
            signatures: [
                { value: '0', text: "Select..." },
            ],
            default_signatories: [],
            default_edit: 1,


            categories: [
                {
                    value: "3", text: "Email Templates", sub_category: [
                        { value: '1', text: "Payslip" },
                        { value: '2', text: "Tax Card" },
                        { value: '3', text: "Certificate" },
                    ]
                },
            ],
            hr_cirtificate:
                [
                    { value: '0', text: "Select..." },
                    { value: '1', text: "Payslip" },
                    { value: '2', text: "Tax Card" },
                    { value: '3', text: "Certificate" },
                ],

        }
    },
    methods: {
        updatePlaceholders() {
            if (this.placeholder && this.placeholder[this.fdata.category] && this.placeholder[this.fdata.category][this.fdata.module_type]) {
                this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                this.editorConfig_default.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                this.componentKey += 1;
            }
        },
        onNamespaceLoaded(CKEDITOR) {
            // CKEDITOR.plugins.addExternal( 'placeholder_select', '../../../../../node_modules/ckeditor4-vue/plugins/placeholder_select/', 'plugin.js' );
            CKEDITOR.plugins.addExternal('placeholder_select', this.$api_url + '/plugin/placeholder_select/', 'plugin.js');
            /* CKEDITOR.stylesSet.add( 'my_styles', [
               // Block-level styles.
               { name: 'Padding15', element: 'td', styles: { padding: '0 15px' } },
               { name: 'Padding30', element: 'td', styles: { padding: '0 30px' } },

           ]);*/

        },
        addNew(x) {

            this.resetForm();
            this.fdata.category = x;
            if (this.placeholder && this.placeholder[this.fdata.category] && this.placeholder[this.fdata.category][this.fdata.module_type]) {
                this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                this.editorConfig_default.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
            }
            this.componentKey += 1;
            this.$bvModal.show('bv-modal-email-template');

        },
        getTemplateData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/email-templates/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.templates = response.data;

                this.getSignatureMappings();

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getSignatureMappings: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/email-templates/signature-mapping', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {

                //console.log('Mapp');
                //console.log(response.data);
                var mapping_templates = [];
                mapping_templates = response.data;
                var signatures_arr = [];
                signatures_arr[0] = '';

                for (var x = 0; x < mapping_templates.length; x++) {

                    signatures_arr[mapping_templates[x].id] = mapping_templates[x];

                }

                this.default_templates = signatures_arr;


                // console.log('Default - Tse');
                // console.log(this.default_templates);




            }.bind(this)).catch(function (error) { console.log(error) });
        },
        getTemplatePlaceholderData() {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/email-templates/placeholder', {
                params: {

                }
            }).then(function (response) {
                this.placeholder = response.data;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        printTemplate: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;


            this.showoverlay = true;
            axios.get(this.$api_url + '/email-templates/details', {
                params: {
                    id: x
                }
            }).then(function (response) {


                this.content = response.data.content;
                //this.$bvModal.show('bv-modal-print');


                this.print();

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
        },
        print() {
            var prtContent = document.getElementById("print");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
        },

        editTemplate: function (x, y) {
            this.getSignatories();

            if (!this.checkNet()) return false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;

            this.showoverlay = true;

            this.default_edit = y;

            axios.get(this.$api_url + '/email-templates/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.signature = response.data.signature_id;
                this.$validator.reset();
                this.successmsg = null;
                this.showoverlay = false;

                if (this.placeholder && this.placeholder[this.fdata.category] && this.placeholder[this.fdata.category][this.fdata.module_type]) {
                    this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                    this.editorConfig_default.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                }
                this.componentKey += 1;

                this.$bvModal.show('bv-modal-email-template');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        addSignatory: function (x) {
            this.getSignatories();

            if (!this.checkNet()) return false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;

            this.showoverlay = true;

            axios.get(this.$api_url + '/email-templates/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.signature = this.default_templates[response.data.id].signature_id;

                this.$validator.reset();
                this.successmsg = null;
                this.showoverlay = false;

                this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];

                this.$bvModal.show('bv-modal-email-signatory-add');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        previewTemplate: function (x) {
            this.getSignatories();

            if (!this.checkNet()) return false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;


            this.showoverlay = true;
            axios.get(this.$api_url + '/email-templates/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.signature = response.data.signature_id;
                this.$validator.reset();
                this.successmsg = null;
                this.showoverlay = false;

                if (this.placeholder && this.placeholder[this.fdata.category] && this.placeholder[this.fdata.category][this.fdata.module_type]) {
                    this.editorConfig.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                    this.editorConfig_default.placeholder_select.placeholders = this.placeholder[this.fdata.category][this.fdata.module_type];
                }
                this.componentKey += 1;

                this.$bvModal.show('bv-modal-email-template-preview');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        deleteTemplate(template_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this template.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.warningmsg = null;
                        this.successmsg = null;

                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', template_id);

                        axios.post(this.$api_url + '/email-templates/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.templates = response.data.templates;

                            }
                            else {
                                this.$bvModal.msgBoxConfirm(response.data.meg, {
                                    title: 'Warning',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'primary',
                                    okTitle: 'Ok',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true
                                });
                            }

                            this.resetPagination();

                            this.showoverlay_list = false;
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay_list = false;
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        duplicate(x) {
            this.fdata.duplicate = x;
        },

        duplicate_template(id) {
            axios.get(this.$api_url + '/email-templates/duplicate', {
                params: {
                    template_id: id
                }
            }).then(function (response) {
                if (response.data.status === false) {
                    this.$bvToast.toast(response.data.meg, {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });
                } else {
                    this.templates = response.data;
                    this.$bvToast.toast('Saved!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                }

                this.showoverlay_list = false;
                this.showoverlay = false;

                this.$bvModal.hide('bv-modal-email-template');
                this.$bvModal.hide('bv-modal-email-template-preview');

            }.bind(this));

        },
        make_default(id) {
            let formData = new FormData();
            formData.append('template_id', id);
            axios.post(this.$api_url + '/email-templates/make_default', formData)
                .then(function (response) {
                    if (response.data.status === false) {
                        this.$bvToast.toast(response.data.meg, {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                    } else {
                        this.templates = response.data;

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        axios.get(this.$api_url + '/email-templates/get_default', {
                            params: {

                            }
                        }).then(function (response) {

                            this.defaults = response.data;


                        }.bind(this))
                            .catch(function (error) {
                                console.log(error);
                            });
                    }

                    this.showoverlay_list = false;
                    this.showoverlay = false;
                    this.$bvModal.hide('bv-modal-email-template');
                    this.$bvModal.hide('bv-modal-email-template-preview');

                }.bind(this));

        },
        // Afrin: Added for send sample email modal start
        send_sample(id) {
            this.sample_email_modal_template_id = id;
            this.sample_email = '';
            this.sample_email_overlay = false;
            this.$nextTick(() => {
                this.$validator.reset();
            });
            this.$bvModal.show('bv-modal-send-sample-email');
        },
        submitSendSample(e) {
            if (e) e.preventDefault();
            this.$validator.validate('sample_email').then(result => {
                if (!result) {
                    return;
                }
                if (!this.checkNet()) return false;
                this.sample_email_overlay = true;
                let formData = new FormData();
                formData.append('template_id', this.sample_email_modal_template_id);
                formData.append('email', this.sample_email);

                axios.post(this.$api_url + '/email-templates/send_sample', formData)
                    .then(function (response) {
                        this.sample_email_overlay = false;
                        if (response.data.status === false) {
                            this.$bvToast.toast(response.data.meg || 'Failed to send email', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            this.$bvModal.hide('bv-modal-send-sample-email');
                            this.$bvToast.toast(response.data.meg || 'Sample email sent successfully!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                    }.bind(this))
                    .catch(function (error) {
                        this.sample_email_overlay = false;
                        this.$bvToast.toast('Error sending email', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }.bind(this));
            });
        },
        // Afrin: Added for send sample email modal end

        download_sample(id) {
            let currentObj = this;
            axios.get(this.$api_url + '/email-templates/download_sample', {
                params: {
                    template_id: id
                }
            }).then(response => {


                var modification_flag = 0;

                var fname = response.data.file_name;

                if (response.data.download_file_name)
                    var download_f_name = response.data.download_file_name;
                else
                    var download_f_name = fname;

                if (download_f_name) {
                    window.location.href = this.$api_url + '/email-templates/downloadzip?file_name=' + fname + '&download_file_name=' + download_f_name + '&modification_flag=' + modification_flag;

                }
            })
                .catch(error => {

                    this.download_loader = false;
                    this.download_text = '';
                });


        },


        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, title: '', subject: '', category: 3, module_type: 1, content: '', has_attachment: 1, duplicate: 0, signature: 0 };
            console.log('Reset');
            this.$nextTick(() => {
                this.$validator.reset();
                this.updatePlaceholders();
            });
        },
        onSubmitSignatory(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);

                }
                //aboni
                if (formData.length > 0) {

                }
                axios.post(this.$api_url + '/email-templates/signatorysave', formData, config)
                    .then(function (response) {
                        if (response.data.status === false) {
                            this.$bvToast.toast(response.data.meg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            this.templates = response.data;

                            this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                            this.$bvModal.hide('bv-modal-email-signatory-add');
                            this.$bvModal.hide('bv-modal-email-template-preview');
                            this.getTemplatePlaceholderData();
                            this.getTemplateData();
                            this.get_default();
                            this.getSignatories();
                        }

                        this.showoverlay_list = false;
                        this.showoverlay = false;

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay_list = false;
                        currentObj.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);

                }

                if (formData.length > 0) {

                }
                axios.post(this.$api_url + '/email-templates/save', formData, config)
                    .then(function (response) {
                        if (response.data.status === false) {
                            this.$bvToast.toast(response.data.meg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            this.templates = response.data;

                            this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                            this.$bvModal.hide('bv-modal-email-template');
                            this.$bvModal.hide('bv-modal-email-template-preview');


                            this.getTemplatePlaceholderData();
                            this.getTemplateData();
                            this.get_default();
                            this.getSignatories();
                        }

                        this.showoverlay_list = false;
                        this.showoverlay = false;

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay_list = false;
                        currentObj.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

        get_default() {
            axios.get(this.$api_url + '/email-templates/get_default', {
                params: {

                }
            }).then(function (response) {
                this.defaults = response.data;
            }.bind(this))
                .catch(function (error) {

                });
            //this.$forceUpdate();



        },

        getSignatories: function () //27-12-21
        {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/signatory', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.signatories = response.data;
                var signatures = [];
                var signatures_arr = [];
                var tempObj = { value: '0', text: "Select..." };
                signatures_arr[0] = '';
                signatures.push(tempObj);

                for (var x = 0; x < this.signatories.length; x++) {
                    var tempObj = {};
                    signatures_arr[this.signatories[x].id] = this.signatories[x].name + " - " + this.signatories[x].designation;
                    tempObj['value'] = this.signatories[x].id;
                    tempObj['text'] = this.signatories[x].name + " - " + this.signatories[x].designation;
                    signatures.push(tempObj);
                }

                this.default_signatories = signatures_arr;
                this.signatures = signatures;



            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
    },
    created: function () {
        this.getTemplatePlaceholderData();
        this.getTemplateData();
        this.get_default();
        this.getSignatories();
    },
    computed:
    {
        moduleTypeName() {
            const typeMap = {
                '1': 'Pay Slip',
                '2': 'Tax Card',
                '3': 'Certificate'
            };
            return typeMap[String(this.fdata.module_type)] || '';
        },
        attachmentLabel() {
            const typeMap = {
                '1': 'Pay Slip',
                '2': 'Tax Card',
                '3': 'Certificate'
            };
            const docName = typeMap[String(this.fdata.module_type)] || 'Document';
            return `Add ${docName} PDF as Attachment?`;
        },
        filteredData() {
            let filtered_list = this.templates['3']; //templates[category.value];

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        rows() {
            return this.templates['3'].length;
        }
    }
}


</script>
